/*
 *
 * MeasurementDetailSimple constants
 *
 */


export const GET_MEASURE_SIMPLE_WATCHER =
  "app/Support/Processes/GET_MEASURE_SIMPLE_WATCHER"
export const GET_MEASURE_SIMPLE_SUCCESS =
  "app/Support/Processes/GET_MEASURE_SIMPLE_SUCCESS"
export const GET_MEASURE_SIMPLE_FAILED =
  "app/Support/Processes/GET_MEASURE_SIMPLE_FAILED"
export const UPDATE_MEASURE_WATCHER =
  "app/Support/Processes/UPDATE_MEASURE_WATCHER"
export const UPDATE_MEASURE_SUCCESS =
  "app/Support/Processes/UPDATE_MEASURE_SUCCESS"
export const UPDATE_MEASURE_FAILED =
  "app/Support/Processes/UPDATE_MEASURE_FAILED"
export const REPROCESS_MEASURE_WATCHER =
  "app/Support/Processes/REPROCESS_MEASURE_WATCHER"
export const REPROCESS_MEASURE_SUCCESS =
  "app/Support/Processes/REPROCESS_MEASURE_SUCCESS"
export const REPROCESS_MEASURE_FAILED =
  "app/Support/Processes/REPROCESS_MEASURE_FAILED"
